import api from '../api'

export default {
    namespaced:true,
    state:{
		cbRoomList:{
		    beanList:[],
		    total:0
		},
		GameDetailList:{
		    beanList:[],
		    total:0
		}
    },
    mutations:{
		setcbRoomListList(state,info){
            state.cbRoomList = info
        },
		setGameDetailList(state,info){
		    state.GameDetailList = info
		}
    },
    actions:{
		getCbGameDetailList({commit},params){
		    return api.post('/system/gameDetailList','牛仔数据详情',params).then(res=>{
		        commit('setGameDetailList',res.data)
		    })
		},
		getCbroomList({commit},params){
		    return api.post('/system/cbroomList','牛仔列表',params).then(res=>{
		        commit('setcbRoomListList',res.data)
		    })
		},
		insertCbRoom(store,params){
		    return api.post('/system/insertCbRoom','创建牛仔',params)
		},
		closeCbRoom(store,params){
		    return api.post('/system/closeCbRoom','关闭牛仔房间',params)
		},
		editCbroom(store,params){
		    return api.post('/system/editCbroom','修改自动开局',params)
		},
        createBroadcast(store,params){
            return api.post('/system/broadcast/broadcastCreate','牌局广播创建',params)
        },
        closeRoom(store,params){
            return api.post('/system/user/force-close','强制解散房间',params)
        },
        sendSysMessage(store,params){
            return api.post('/system/message/sendSysMessage','发送系统消息',params)
        },
        getcbConfig(store,params){
            return api.post('/system/cbconfig','获取牛仔配置',params)
        },
        setCbConfig(store,params){
            return api.post('/system/setCbConfig','修改牛仔配置',params)
        }
    }
}